import { createSelector, createSlice } from "@reduxjs/toolkit";
import { resetproject } from "../resetParameters";

export const Measurements = Object.freeze({
  METRIC: 0,
  IMPERIAL: 1,
});

const initialState = {
  measurementType: Measurements.IMPERIAL,
  // add default Language
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setMeasurementType(state, action) {
      state.measurementType = Number(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetproject, (state, action) => {
      return initialState;
    });
  },
});

export const { setMeasurementType } = settingsSlice.actions;
export default settingsSlice.reducer;

export const selectMeasurementType = (state) => {
  return Number(state.settings.measurementType);
};

export const selectIsImperial = createSelector(
  [selectMeasurementType],
  (measurement) => measurement === Measurements.IMPERIAL
);
export const selectIsMetric = createSelector(
  [selectMeasurementType],
  (measurement) => measurement === Measurements.METRIC
);
